
import React, { useEffect, useState } from 'react';
import axios from "axios";
import {
    Image as ImageIcon, ChevronLeft, ChevronRight,
    MoreHorizontal, ThumbsUp, MessageCircle, Share2,
    Phone, Eye, ShoppingCart, Calendar, CreditCard,
    UserCircle, Download, Clock, Grid3x3, Search, Smartphone, Globe, Store, Users, Mail, UtensilsCrossed, ShoppingBag
} from 'lucide-react';
import { Button } from "@mui/material";
// import { createCampaign, getVendorDetails } from "../../../Service/APIServices/campaignService";
// import { useLoader } from '../../../context/LoaderProvider';
// import { MAIN_API, RAZORPAY_KEY_ID } from '../../../config/api';
const APP_TYPES = [
    { value: "FOOD_AND_BEVERAGES", label: "Food & Beverages" },
    { value: "CATERINGS_SERVICES", label: "Catering Services" }
];
const AdPreview = ({ formData, goals, subGoals, callToActionOptions, screensData = [], mediumOptions, audienceOptions, mediaTypeOptions, interestOptions, showPayment, discountValue, discountMode, menuItems, groupedItems, onInputChange, selectedDiscountItems,
    selectedBogoItems,
    itemDiscounts = {}, bogoItems, }) => {
    const [adFormat, setAdFormat] = useState("facebook");
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [captionExpanded, setCaptionExpanded] = useState(false);
    const [billingData, setBillingData] = useState(null);
    const [vendorMobile, setVendorMobile] = useState("");
    const formats = ["facebook", "instagram_feed", "instagram_story"];
    const startDate = formData?.goalConfig?.discount?.startDate;
    const endDate = formData?.goalConfig?.discount?.endDate;
    const formatDate = (date) => {
        if (!date) return "";
        const d = new Date(date);

        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();

        return `${day}/${month}/${year}`;
    };
    // const locations =
    //     formData?.goalConfig?.leads?.locations ||
    //     formData?.goalConfig?.advertisement?.locations ||
    //     formData?.locations ||
    //     [];
    const locations =
        formData?.goalConfig?.leads?.locations || [];
    const leads = formData?.goalConfig?.leads || {};
    const allItems = Object.values(groupedItems || {}).flat();
    const selectedItems =
        formData.goal === "BOGO_DISCOUNT"
            ? (selectedBogoItems || [])
            : (selectedDiscountItems || []);


    const goal = formData?.goal;   // ✅ ADD THIS
    const discount = formData?.goalConfig?.discount || {};
    const interests = formData?.goalConfig?.leads?.interests || [];
    const days = formData?.days || 1;
    const reach = formData?.reach || 0;
    const [totalAmount, setTotalAmount] = useState(0);
    const [couponDiscount, setCouponDiscount] =
        useState(0);

    const [couponApplied, setCouponApplied] =
        useState(false);
    // const adPreviewRef = useRef(null);
    // If you really need these constants
    const PRICE_PER_DAY = 100;      // change as per your logic
    const COST_PER_REACH = 1;       // change as per your logic
    const totalPrice = (days * PRICE_PER_DAY) + (reach * COST_PER_REACH);
    const dailyCost = totalPrice / days;
    const placementsByMedium = {
        app: [
            { value: 'home_banner', label: 'Home Banner', icon: Smartphone },
            { value: 'app_feed', label: 'App Feed', icon: Grid3x3 }
        ],
        digital: [
            { value: 'website_banner', label: 'Website Banner', icon: Globe },
            { value: 'social_ads', label: 'Social Ads', icon: Users }
        ],
        physical: [
            { value: 'store_banner', label: 'Store Banner', icon: Store },
            { value: 'flyers', label: 'Flyers', icon: Mail }
        ]
    };
    const allPlacements = Object.values(placementsByMedium).flat();
    const captionText =
        formData?.mediaDescriptions?.image ||
        formData?.mediaDescriptions?.video ||
        "";
    const subGoalCTA = {
        whatsapp_messages: {
            label: "Send Message", bg: "#25D366", color: "#fff",
            icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" /><path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.126 1.532 5.859L.06 23.4l5.701-1.494A11.946 11.946 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.853 0-3.587-.503-5.076-1.38l-.363-.214-3.785.992 1.01-3.683-.236-.374A9.96 9.96 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" /></svg>
        },
        more_messages: { label: "Send Message", bg: "#1877f2", color: "#fff", icon: <MessageCircle size={13} color="#fff" /> },
        more_calls: { label: "Call Now", bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Phone size={13} color="#111827" /> },
        more_page_likes: { label: "Like Page", bg: "#1877f2", color: "#fff", icon: <ThumbsUp size={13} color="#fff" /> },
        more_leads: { label: "Get Quote", bg: "#1877f2", color: "#fff", icon: <UserCircle size={13} color="#fff" /> },
        boost_facebook: { label: "Follow Page", bg: "#1877f2", color: "#fff", icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="#fff"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg> },
        boost_instagram: { label: "Follow", bg: "#E1306C", color: "#fff", icon: <svg width="13" height="13" viewBox="0 0 24 24" fill="#fff"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" /></svg> },
        website_visitors: { label: "Visit Website", bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Eye size={13} color="#111827" /> },
        page_visits_followers: { label: "Follow Page", bg: "#1877f2", color: "#fff", icon: <UserCircle size={13} color="#fff" /> },
        new_customers: { label: "Shop Now", bg: "#1877f2", color: "#fff", icon: <ShoppingCart size={13} color="#fff" /> },
        existing_customers: { label: "Book Now", bg: "#1877f2", color: "#fff", icon: <Calendar size={13} color="#fff" /> },
        high_value: { label: "Get Quote", bg: "#854F0B", color: "#fff", icon: <CreditCard size={13} color="#fff" /> },
        automated_ads: { label: "Learn More", bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Eye size={13} color="#111827" /> },
        ab_test: { label: "Learn More", bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Eye size={13} color="#111827" /> },
        awareness: { label: "Learn More", bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Eye size={13} color="#111827" /> },
        recall: { label: "Learn More", bg: "#1877f2", color: "#fff", icon: <Eye size={13} color="#fff" /> },
        premium: { label: "Get Quote", bg: "#854F0B", color: "#fff", icon: <CreditCard size={13} color="#fff" /> },
        order_now: {
            bg: "#1877f2",
            color: "#fff",
            border: "none",
            icon: <ShoppingBag size={13} color="#fff" />
        },
    };
    const applyCoupon = () => {


    };



    const discountType =
        formData?.goalConfig?.discount?.discountType || "";

    const safeMediums = formData?.mediums || [];
    const safePlacements = formData?.placements || [];
    // const discountValue = discount?.value;

    // const discountMode = discount?.type; // percentage / flat
    const isDigitalScreenSelected =
        safeMediums.includes("digital") &&
        safePlacements.length > 0;

    const safeMedia =
        formData?.videoFile || // ✅ FIRST check video
        formData?.images?.[formData.images.length - 1] || // then image
        "";

    const mediaType = formData?.videoFile ? "video" : "image";


    const ctaStyleMap = {
        apply_now: { bg: "#1877f2", color: "#fff", border: "none", icon: <UserCircle size={13} color="#fff" /> },
        book_now: { bg: "#1877f2", color: "#fff", border: "none", icon: <Calendar size={13} color="#fff" /> },
        contact_us: { bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Phone size={13} color="#111827" /> },
        download: { bg: "#1877f2", color: "#fff", border: "none", icon: <Download size={13} color="#fff" /> },
        learn_more: { bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Eye size={13} color="#111827" /> },
        request_time: { bg: "#1877f2", color: "#fff", border: "none", icon: <Clock size={13} color="#fff" /> },
        see_menu: { bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Grid3x3 size={13} color="#111827" /> },
        shop_now: { bg: "#1877f2", color: "#fff", border: "none", icon: <ShoppingCart size={13} color="#fff" /> },
        sign_up: { bg: "#1877f2", color: "#fff", border: "none", icon: <UserCircle size={13} color="#fff" /> },
        watch_more: { bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Eye size={13} color="#111827" /> },
        send_message: { bg: "#1877f2", color: "#fff", border: "none", icon: <MessageCircle size={13} color="#fff" /> },
        get_quote: { bg: "#1877f2", color: "#fff", border: "none", icon: <CreditCard size={13} color="#fff" /> },
        get_directions: { bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Search size={13} color="#111827" /> },
        call_now: { bg: "#f1f5f9", color: "#111827", border: "0.5px solid #d1d5db", icon: <Phone size={13} color="#111827" /> },
        order_now: {
            bg: "#1877f2",
            color: "#fff",
            border: "none",
            icon: <ShoppingBag size={13} color="#fff" />
        },
    };
    // Inside your component

    useEffect(() => {
        const fetchVendor = () => {

        };

        fetchVendor();
    }, []);

    useEffect(() => {
        const fetchBilling = () => {

        };



        if (
            showPayment &&
            (
                formData.goal === "discount" ||
                formData.goal === "BOGO_DISCOUNT"
            )
        ) {
            fetchBilling();
        }

    }, [showPayment, formData.goal]);

    // const selectedItems =
    //     formData.goalConfig?.discount?.selectedItems || [];

    const startTime =
        formData.goalConfig?.discount?.startTime || "";

    const endTime =
        formData.goalConfig?.discount?.endTime || "";

    const timeCategory =
        formData.goalConfig?.discount?.timeCategory || "";



    // const selectedItems =
    //     formData.goalConfig?.discount?.selectedItems || [];

    const displayName = formData.campaignName || formData.name || "Your Business";
    const initials = displayName !== "Your Business"
        ? displayName.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase()
        : "YB";

    const ctaLabel = callToActionOptions?.find(c => c.value === formData.callToAction)?.label;
    const ctaIcon = callToActionOptions?.find(
        c => c.value === formData.callToAction
    )?.icon;
    const sg = subGoalCTA[formData.subGoal];
    const cs = ctaStyleMap[formData.callToAction];
    const investment = Number(formData.investment || 0);
    const gst = investment * 0.18;
    const finalAmount = investment + gst;
    const mapCTAForBackend = (cta) => {
        if (!cta) return null;

        const mapping = {
            enquire_now: "ENQUIRE_NOW",   // ✅ FIX
        };

        return mapping[cta] || cta.toUpperCase();
    };


    const handlePayment = () => {
    }

    const handleSubmit = () => { }

   const handleScreenSubmit= () => {}


    const getCTAButton = (iconSize = 13, textColor = null) => {
        const selectedCTA = formData.callToAction;

        const option = callToActionOptions?.find(
            c => c.value === selectedCTA
        );

        const cs = ctaStyleMap?.[selectedCTA];
        const sg = subGoalCTA?.[formData.subGoal];

        // ✅ Priority 1: User selected CTA
        if (option && cs) {
            return {
                label: option.label,
                bg: cs.bg,
                color: textColor || cs.color,
                border: cs.border,
                icon: cs.icon
            };
        }

        // ✅ Priority 2: SubGoal CTA fallback
        if (sg) {
            return sg;
        }

        // ✅ Default fallback
        return {
            label: "Visit Page",
            bg: "#f1f5f9",
            color: "#111827",
            border: "0.5px solid #d1d5db",
            icon: null
        };
    };

    const navArrow = (dir) => ({
        position: "absolute",
        [dir]: 6,
        top: "50%",
        transform: "translateY(-50%)",
        width: 28, height: 28,
        zIndex: 999,
        borderRadius: "50%",
        backgroundColor: "#1877f2",
        border: "none", cursor: "pointer",
        display: "flex", alignItems: "center", justifyContent: "center"
    });

    const dots = (bottomVal = 6) => (
        <div style={{ position: "absolute", bottom: bottomVal, left: "50%", transform: "translateX(-50%)", display: "flex", gap: 4 }}>
            {formats.map(fmt => (
                <div key={fmt} onClick={() => setAdFormat(fmt)} style={{ width: adFormat === fmt ? 16 : 6, height: 6, borderRadius: "3px", backgroundColor: adFormat === fmt ? "#fff" : "rgba(255,255,255,0.5)", cursor: "pointer", transition: "width 0.2s" }} />
            ))}
        </div>
    );

    const prevFmt = () => setAdFormat(formats[(formats.indexOf(adFormat) - 1 + formats.length) % formats.length]);
    const nextFmt = () => setAdFormat(formats[(formats.indexOf(adFormat) + 1) % formats.length]);

    const hasMedia = formData.images?.length > 0 || formData.videoFile;
    const mediaEl = (height) => formData.images?.length > 0
        ? <img src={formData.images[currentImageIndex]} alt="Ad" style={{ width: "100%", height, objectFit: "cover", display: "block" }} />
        : <video src={formData.videoFile} style={{ width: "100%", height, objectFit: "cover", display: "block" }} />;

    return (
        <div className="premium-cards premium-summary-card">

            {/* Header */}
            <div className="premium-card__header" style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "16px", borderBottom: "0.5px solid #e5e7eb" }}>
                <h2 className="premium-card__title" style={{ margin: 0, fontSize: "16px", fontWeight: "bold", color: "#111827", justifyContent: "center" }}>Ad Preview</h2>
            </div>

            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    padding: "12px 16px",
                    // borderBottom: "0.5px solid #f0f0f0"
                }}
            >

                {/* Goal */}
                {formData.goal && (
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "130px 1fr",
                            alignItems: "center",
                            gap: "58px",
                        }}
                    >
                        <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                            Goal
                        </span>

                        <span
                            style={{
                                fontSize: "13px",
                                fontWeight: 600,
                                backgroundColor: "#eff6ff",
                                color: "#185FA5",
                                borderRadius: "5px",
                                padding: "4px 10px",
                                width: "fit-content"
                            }}
                        >
                            {goals?.find(g => g.value === formData.goal)?.label}
                        </span>
                    </div>
                )}
                {formData.goal !== "discount" && formData.goal !== "BOGO_DISCOUNT" && discountType !== "" && (
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "130px 1fr",
                            alignItems: "center",
                            gap: "58px"
                        }}
                    >
                        <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                            Campaign Name
                        </span>

                        <span
                            style={{
                                fontSize: "13px",
                                fontWeight: 600,
                                backgroundColor: "#eff6ff",
                                color: "#185FA5",
                                borderRadius: "5px",
                                padding: "4px 10px",
                                width: "fit-content"
                            }}
                        >
                            {displayName}
                        </span>
                    </div>
                )}
                {/* Sub Goal */}
                {
                    formData.goal === "BOGO_DISCOUNT" &&
                    bogoItems?.filter(item => item.selected)?.length > 0 && (

                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                gap: "58px",
                                padding: "4px 0",
                                alignItems: "start"
                            }}
                        >

                            <span
                                style={{
                                    fontSize: "11px",
                                    color: "#000",
                                    fontWeight: "bold"
                                }}
                            >
                                BOGO Items
                            </span>

                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "6px"
                                }}
                            >

                                {
                                    bogoItems
                                        .filter(item => item.selected)
                                        .map(item => (

                                            <span
                                                key={item.id}
                                                style={{
                                                    fontSize: "13px",
                                                    fontWeight: 600,
                                                    backgroundColor: "#f0fdf4",
                                                    color: "#3B6D11",
                                                    borderRadius: "5px",
                                                    padding: "4px 10px",
                                                    width: "fit-content"
                                                }}
                                            >
                                                {item.name}
                                                {" | "}
                                                Buy {item.buyQty || 0}
                                                {" → "}
                                                Get {item.getQty || 0}
                                            </span>

                                        ))
                                }

                            </div>

                        </div>

                    )
                }
            </div>

            <div style={{ marginTop: "-10px" }}>
                {
                    formData.goal === "discount" && formData.subGoal === "menu" && discountType !== "" && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                gap: "58px",
                                paddingTop: "6px",
                                marginLeft: "13px"
                            }}
                        >
                            <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", marginLeft: "5px" }}>
                                Discount Type
                            </span>

                            <span
                                style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    backgroundColor:
                                        discountType === "overall" ? "#e0f2fe" : "#fef3c7",
                                    color:
                                        discountType === "overall" ? "#0369a1" : "#92400e",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}
                            >
                                {discountType === "overall"
                                    ? "🍽️ Overall Menu"
                                    : "🎯 Specific Items"}
                            </span>
                        </div>
                    )
                }
                {formData.goal === "discount" &&
                    formData.subGoal === "menu" &&
                    discountType === "overall" &&
                    formData?.goalConfig?.discount?.discountValue && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                gap: "58px",
                                paddingTop: "6px",
                                marginLeft: "13px"
                            }}
                        >
                            <span
                                style={{
                                    fontSize: "11px",
                                    color: "#000",
                                    fontWeight: "bold",
                                    marginLeft: "5px"
                                }}
                            >
                                Discount Value
                            </span>

                            <span
                                style={{
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    backgroundColor: "#ecfdf5",
                                    color: "#065f46",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}
                            >
                                🔥 {formData.goalConfig.discount.discountValue}% OFF
                            </span>
                        </div>
                    )}
                {
                    discountType === "specific" && selectedItems?.length > 0 && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                alignItems: "center",
                                gap: "70px",
                                padding: "4px 0"
                            }}
                        >
                            <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", marginLeft: "22px" }}>
                                Items:
                            </span>

                            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                {selectedItems.map(item => (
                                    <span
                                        key={item.id}
                                        style={{
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            backgroundColor: "#fef3c7",
                                            color: "#92400e",
                                            borderRadius: "5px",
                                            padding: "4px 8px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px"
                                        }}
                                    >
                                        {item.name}

                                        {/* ✅ ADD DISCOUNT HERE */}
                                        {item.discountValue && (
                                            <span style={{ color: "#16a34a", fontWeight: 700 }}>
                                                ({item.discountValue}%)
                                            </span>
                                        )}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )
                }

                {/* In AdPreview.jsx, add this where other fields are displayed */}
                {formData.goal === "BOGO_DISCOUNT" && formData.goalConfig?.discount?.orderType && (
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "130px 1fr",
                        alignItems: "center",
                        gap: "70px",
                        padding: "4px 0"
                    }}>
                        <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", marginLeft: "22px" }}>
                            Order Type:
                        </span>
                        <span style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            backgroundColor: "#f0fdf4",
                            color: "#3B6D11",
                            borderRadius: "5px",
                            padding: "4px 10px",
                            width: "fit-content"
                        }}>
                            {{
                                DINE_IN: "🍽️ Dine In",
                                TAKEAWAY: "📦 Take Away",
                                DELIVERY: "🚚 Delivery",
                                ALL: "🔄 All Types"
                            }[formData.goalConfig.discount.orderType] || formData.goalConfig.discount.orderType}
                        </span>
                    </div>
                )}
                {formData.goal === "discount" && formData.subGoal === "coupons" && (
                    <>
                        {/* Coupon Code */}
                        {formData.goalConfig?.discount?.couponCode && (
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                gap: "58px",
                                paddingTop: "6px",
                                marginLeft: "13px"
                            }}>
                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                    Coupon Code:
                                </span>

                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    backgroundColor: "#eff6ff",
                                    color: "#1d4ed8",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}>
                                    🎟️ {formData.goalConfig.discount.couponCode}
                                </span>
                            </div>
                        )}
                        {formData.goal === "discount" && discountValue && (
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    gap: "58px",
                                    paddingTop: "6px",
                                    marginLeft: "13px"
                                }}
                            >
                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                    Discount Value:
                                </span>

                                <span
                                    style={{
                                        fontSize: "11px",
                                        fontWeight: 700,
                                        backgroundColor: "#ecfdf5",
                                        color: "#065f46",
                                        borderRadius: "5px",
                                        padding: "4px 10px",
                                        width: "fit-content"
                                    }}
                                >
                                    {discountMode === "percentage"
                                        ? `🔥 ${discountValue}% OFF`
                                        : `💰 ₹${discountValue} OFF`}
                                </span>
                            </div>
                        )}
                        {/* Discount Type */}
                        {formData.goalConfig?.discount?.discountType && (
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                gap: "58px",
                                paddingTop: "6px",
                                marginLeft: "13px"
                            }}>
                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                    Discount Type:
                                </span>

                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    backgroundColor: "#fef3c7",
                                    color: "#92400e",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}>
                                    {formData.goalConfig.discount.discountType === "PERCENTAGE"
                                        ? "📊 Percentage"
                                        : "💰 Fixed Amount"}
                                </span>
                            </div>
                        )}

                        {/* Coupon Type */}
                        {formData.goalConfig?.discount?.couponType && (
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                gap: "58px",
                                paddingTop: "6px",
                                marginLeft: "13px"
                            }}>
                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                    Coupon Type:
                                </span>

                                <span style={{
                                    fontSize: "13px",
                                    fontWeight: 700,
                                    backgroundColor: "#ecfdf5",
                                    color: "#065f46",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}>
                                    {formData.goalConfig.discount.couponType === "FLAT"
                                        ? "🏷️ Flat"
                                        : "⬆️ Upto"}
                                </span>
                            </div>
                        )}
                        {formData.goalConfig?.discount?.minimumOrderValue && (
                            <div
                                style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    gap: "58px",
                                    paddingTop: "6px",
                                    marginLeft: "13px"
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: "11px",
                                        color: "#000",
                                        fontWeight: "bold"
                                    }}
                                >
                                    Minimum Order:
                                </span>

                                <span
                                    style={{
                                        fontSize: "13px",
                                        fontWeight: 700,
                                        backgroundColor: "#ecfdf5",
                                        color: "#065f46",
                                        borderRadius: "5px",
                                        padding: "4px 10px",
                                        width: "fit-content"
                                    }}
                                >
                                    💰 ₹ {formData.goalConfig.discount.minimumOrderValue}
                                </span>
                            </div>
                        )}
                    </>
                )}


                {/* 🔥 TIME SLOT */}
                {
                    startTime && endTime && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                alignItems: "center",
                                gap: "70px",
                                padding: "4px 0"
                            }}
                        >
                            <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", marginLeft: "22px" }}>
                                Time:
                            </span>

                            <span
                                style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    backgroundColor: "#f3f4f6",
                                    color: "#374151",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}
                            >
                                ⏰ {startTime} - {endTime}
                            </span>
                        </div>
                    )
                }
                {
                    startDate && endDate && (
                        <div
                            style={{
                                display: "grid",
                                gridTemplateColumns: "130px 1fr",
                                alignItems: "center",
                                gap: "58px",
                                padding: "4px 0"
                            }}
                        >
                            <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", marginLeft: "22px" }}>
                                Date:
                            </span>

                            <span
                                style={{
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    backgroundColor: "#eff6ff",
                                    color: "#1d4ed8",
                                    borderRadius: "5px",
                                    padding: "4px 10px",
                                    width: "fit-content"
                                }}
                            >
                                {formatDate(startDate)} → {formatDate(endDate)}
                            </span>
                        </div>
                    )
                }
                {/* 🔥 TIME CATEGORY */}
                {timeCategory && (
                    <div style={{
                        display: "grid",
                        gridTemplateColumns: "130px 1fr",
                        alignItems: "center",
                        gap: "70px",
                        padding: "4px 0"
                    }}>
                        <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", marginLeft: "22px" }}>
                            Category:
                        </span>
                        <span style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            backgroundColor: "#f0fdf4",
                            color: "#3B6D11",
                            borderRadius: "5px",
                            padding: "4px 10px",
                            width: "fit-content"
                        }}>
                            {/* ✅ Convert enum → readable label for display */}
                            {{
                                PEAK_HOURS: "🔥 Peak Hours",
                                RAINING_TIME: "🌧️ Raining Time",
                                HAPPY_HOURS: "🎉 Happy Hours",
                                LUNCH_TIME: "🍽️ Lunch Time",
                                DINNER_TIME: "🌙 Dinner Time",
                                EARLY_MORNING: "🌅 Early Morning",
                                LATE_NIGHT: "🌃 Late Night",
                                WEEKEND_SPECIAL: "🎊 Weekend Special"
                            }[timeCategory] || timeCategory}
                        </span>
                    </div>
                )}


                {/* Selected Options Summary */}
                {
                    (formData.mediums?.length > 0 || formData.audience?.length > 0 || formData.mediaTypes?.length > 0 || formData.callToAction) && (
                        <div style={{ padding: "8px 16px", }}>
                            {formData.mediums?.length > 0 && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    padding: "4px 0",
                                    marginBottom: "10px"
                                }}>
                                    <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", minWidth: 85, paddingTop: 2 }}>Medium</span>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                        {formData.mediums.map(m => {
                                            const opt = mediumOptions?.find(o => o.value === m);
                                            const Icon = opt?.icon;
                                            return (
                                                <span key={m} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: "11px", backgroundColor: "#eff6ff", color: "#185FA5", borderRadius: "5px", padding: "2px 8px", fontWeight: 500 }}>
                                                    {Icon && <Icon size={11} />} {opt?.label}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {formData.appTypes?.length > 0 && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    padding: "4px 0",
                                    marginBottom: "10px",

                                }}>
                                    <span style={{
                                        fontSize: "11px",
                                        color: "#000", fontWeight: "bold",
                                        minWidth: 85,
                                        paddingTop: 2
                                    }}>
                                        Business
                                    </span>

                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                        {formData.appTypes.map(type => {
                                            const opt = APP_TYPES.find(o => o.value === type);
                                            return (
                                                <span
                                                    key={type}
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: 4,
                                                        fontSize: "13px",
                                                        backgroundColor: "#ecfdf5",
                                                        color: "#065f46",
                                                        borderRadius: "5px",
                                                        padding: "2px 8px",
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {opt?.label}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                            {formData.durationSeconds && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    padding: "4px 0",
                                    marginBottom: "10px"
                                }}>
                                    <span style={{
                                        fontSize: "11px",
                                        color: "#000", fontWeight: "bold",
                                        minWidth: 85,
                                        paddingTop: 2
                                    }}>
                                        Ad Duration
                                    </span>

                                    <span style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        backgroundColor: "#fef9ec",
                                        color: "#854F0B",
                                        borderRadius: "5px",
                                        padding: "2px 8px"
                                    }}>
                                        ⏱ {formData.durationSeconds} sec
                                    </span>
                                </div>
                            )}
                            {Array.isArray(formData.placements) && formData.placements.length > 0 && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    marginBottom: "10px"
                                }}>
                                    <span style={{
                                        fontSize: "11px",
                                        color: "#000", fontWeight: "bold",
                                        minWidth: 85,
                                        paddingTop: 2
                                    }}>
                                        Placements
                                    </span>

                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                        {formData.placements.map(p => {

                                            // ✅ 1. Check if it's DIGITAL SCREEN
                                            const screen = screensData.find(s => s.id === p);

                                            // ✅ 2. If screen exists → DIGITAL
                                            if (screen) {
                                                return (
                                                    <span
                                                        key={p}
                                                        style={{
                                                            display: "inline-flex",
                                                            flexDirection: "column",
                                                            gap: 2,
                                                            fontSize: "11px",
                                                            backgroundColor: "#ecfeff",
                                                            color: "#0e7490",
                                                            borderRadius: "6px",
                                                            padding: "6px 10px",
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        📺 {screen.name}

                                                        <span style={{ fontSize: "10px", color: "#6b7280" }}>
                                                            {screen.deviceId}
                                                        </span>

                                                        <span style={{ fontSize: "10px", color: "#6b7280" }}>
                                                            {screen.resolution}
                                                        </span>
                                                    </span>
                                                );
                                            }

                                            // ✅ 3. Else → NORMAL PLACEMENT
                                            const opt = allPlacements.find(o => o.value === p);
                                            const Icon = opt?.icon;

                                            return (
                                                <span
                                                    key={p}
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: 4,
                                                        fontSize: "11px",
                                                        backgroundColor: "#eff6ff",
                                                        color: "#185FA5",
                                                        borderRadius: "5px",
                                                        padding: "2px 8px",
                                                        fontWeight: 500
                                                    }}
                                                >
                                                    {Icon && <Icon size={11} />}
                                                    {opt?.label || p}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {formData.mediaTypes?.length > 0 && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    padding: "4px 0",
                                    marginBottom: "10px"
                                }}>
                                    <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", minWidth: 85, paddingTop: 2 }}>Media Type</span>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                        {formData.mediaTypes.map(m => {
                                            const opt = mediaTypeOptions?.find(o => o.value === m);
                                            const Icon = opt?.icon;
                                            return (
                                                <span key={m} style={{ display: "inline-flex", alignItems: "center", gap: 4, fontSize: "11px", backgroundColor: "#fef9ec", color: "#854F0B", borderRadius: "5px", padding: "2px 8px", fontWeight: 500 }}>
                                                    {Icon && <Icon size={11} />} {opt?.label}
                                                    {formData.mediaDurations?.[m] && ` · ${formData.mediaDurations[m]}s`}
                                                </span>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            {locations.length > 0 && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    padding: "4px 0",
                                    marginBottom: "10px"
                                }}>
                                    <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                        Locations
                                    </span>

                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                        {locations.map(loc => (
                                            <div
                                                key={loc.placeId}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    backgroundColor: "#eff6ff",
                                                    border: "1px solid #bfdbfe",
                                                    borderRadius: "6px",
                                                    padding: "4px 8px",
                                                    fontSize: "11px",
                                                    color: "#1e40af",
                                                    fontWeight: 500
                                                }}
                                            >
                                                {/* 📍 Location Name */}
                                                <span>📍 {loc.name}</span>

                                                {/* 🌍 Latitude & Longitude */}
                                                {/* <span style={{ fontSize: "10px", color: "#6b7280" }}>
                                                    Lat: {loc.latitude || loc.lat || "-"} ,
                                                    Lng: {loc.longitude || loc.lng || "-"}
                                                </span> */}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {formData.callToAction && (
                                <div style={{
                                    display: "grid",
                                    gridTemplateColumns: "130px 1fr",
                                    alignItems: "center",
                                    gap: "58px",
                                    padding: "4px 0"
                                }}>
                                    <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold", minWidth: 85 }}>CTA</span>
                                    <span style={{ fontSize: "11px", backgroundColor: "#f5f3ff", color: "#534AB7", borderRadius: "5px", padding: "2px 8px", fontWeight: 600 }}>
                                        {ctaLabel}
                                    </span>
                                </div>
                            )}




                            {
                                goal === "leads" && (
                                    <div style={{
                                        padding: "8px 0px",
                                        // borderBottom: "0.5px solid #e5e7eb", 
                                        gap: "36px",
                                        marginTop: "-2px"
                                    }}>

                                        {/* Gender */}
                                        {leads.gender && (
                                            <div style={{
                                                display: "grid",
                                                gridTemplateColumns: "130px 1fr",
                                                alignItems: "center",
                                                gap: "66px",
                                                padding: "4px 0"
                                            }}>
                                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>Gender</span>
                                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                                    {leads.gender.toUpperCase()}
                                                </span>
                                            </div>
                                        )}

                                        {/* Age */}
                                        {leads.ageRange && (
                                            <div style={{
                                                display: "grid",
                                                gridTemplateColumns: "130px 1fr",
                                                alignItems: "center",
                                                gap: "66px",
                                                padding: "4px 0"
                                            }}>
                                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>Age</span>
                                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                                    {leads.ageRange[0]} - {leads.ageRange[1]}
                                                </span>
                                            </div>
                                        )}

                                        {/* Mobile */}
                                        {leads.contactMobile && (
                                            <div style={{
                                                display: "grid",
                                                gridTemplateColumns: "130px 1fr",
                                                alignItems: "center",
                                                gap: "58px",
                                                padding: "4px 0"
                                            }}>
                                                <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>Mobile</span>
                                                <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                                                    📞 {leads.contactMobile}
                                                </span>
                                            </div>
                                        )}

                                    </div>
                                )
                            }


                            {
                                goal === "leads" && interests.length > 0 && (
                                    <div
                                        style={{
                                            // padding: "8px 16px",
                                            // borderBottom: "0.5px solid #e5e7eb"
                                        }}
                                    >
                                        <div style={{
                                            display: "grid",
                                            gridTemplateColumns: "130px 1fr",
                                            alignItems: "center",
                                            gap: "59px",
                                            padding: "4px 0"
                                        }}>
                                            <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                                Audience
                                            </span>

                                            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                                {interests.map((val) => {
                                                    const opt = interestOptions?.find(o => o.value === val);

                                                    return (
                                                        <span
                                                            key={val}
                                                            style={{
                                                                fontSize: "11px",
                                                                backgroundColor: "#f0fdf4",
                                                                color: "#3B6D11",
                                                                borderRadius: "5px",
                                                                padding: "2px 8px",
                                                                fontWeight: 500
                                                            }}
                                                        >
                                                            {opt?.label || val}
                                                        </span>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            {(formData.startDate || formData.endDate) && (
                                <div
                                    style={{
                                        marginTop: "-2px",
                                        // marginBottom: "10px",
                                        padding: "10px 0px",
                                        borderRadius: "10px",
                                        // backgroundColor: "#f1f5f9",
                                        // border: "1px solid #e2e8f0",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "36px"
                                    }}
                                >
                                    {/* Start Date */}
                                    <div style={{ flex: 1 }}>
                                        <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                            Start Date
                                        </span>
                                        <div style={{
                                            fontSize: "13px",
                                            fontWeight: 700,
                                            color: "#1e40af"
                                        }}>
                                            {formData.startDate || "—"}
                                        </div>
                                    </div>

                                    {/* End Date */}
                                    <div style={{ flex: 1 }}>
                                        <span style={{ fontSize: "11px", color: "#000", fontWeight: "bold" }}>
                                            End Date
                                        </span>
                                        <div style={{
                                            fontSize: "13px",
                                            fontWeight: 700,
                                            color: "#1e40af"
                                        }}>
                                            {formData.endDate || "—"}
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* {
                                goal === "leads" && locations.length > 0 && (
                                    <div
                                        style={{
                                            padding: "8px 16px",
                                            borderBottom: "0.5px solid #e5e7eb"
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "130px 1fr",
                                                alignItems: "center",
                                                gap: "58px",
                                                padding: "4px 0"
                                            }}
                                        >
                                            <span style={{ fontSize: "11px", color: "#9ca3af" }}>
                                                Locations
                                            </span>

                                            <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                                                {locations.map((loc) => (
                                                    <span
                                                        key={loc.placeId}
                                                        style={{
                                                            fontSize: "11px",
                                                            backgroundColor: "#eff6ff",
                                                            color: "#185FA5",
                                                            borderRadius: "5px",
                                                            padding: "2px 8px",
                                                            fontWeight: 500
                                                        }}
                                                    >
                                                        📍 {loc.name}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                )
                            } */}
                        </div>
                    )
                }


            </div>
            {/* Ad Preview */}
            {hasMedia && (
                <>
                    {isDigitalScreenSelected ? (
                        <div
                            style={{
                                width: "100%",
                                height: "400px",
                                borderRadius: "12px",
                                overflow: "hidden",
                                background: "#000",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "relative" // ✅ IMPORTANT for overlay
                            }}
                        >
                            {/* ✅ MEDIA */}
                            {safeMedia ? (
                                mediaType === "video" ? (
                                    <video
                                        key={safeMedia}
                                        src={safeMedia}
                                        controls
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            backgroundColor: "#000"
                                        }}
                                    />
                                ) : (
                                    <img
                                        src={safeMedia}
                                        alt="preview"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }}
                                    />
                                )
                            ) : (
                                <p style={{ color: "#fff" }}>No media selected</p>
                            )}

                            {/* ✅ DESCRIPTION OVERLAY */}
                            {(formData.mediaDescriptions?.image || formData.mediaDescriptions?.video) && (
                                <div
                                    style={{
                                        position: "absolute",
                                        bottom: "0",
                                        left: "0",
                                        right: "0",
                                        padding: "10px 12px",
                                        background: "linear-gradient(transparent, rgba(0,0,0,0.8))",
                                        color: "#fff"
                                    }}
                                >
                                    <p
                                        style={{
                                            margin: 0,
                                            fontSize: "13px",
                                            lineHeight: 1.5
                                        }}
                                    >
                                        {(() => {
                                            const text =
                                                formData.mediaDescriptions?.image ||
                                                formData.mediaDescriptions?.video;

                                            return captionExpanded || text.length <= 80
                                                ? text
                                                : `${text.slice(0, 80)}...`;
                                        })()}
                                    </p>

                                    {(formData.mediaDescriptions?.image ||
                                        formData.mediaDescriptions?.video)?.length > 80 && (
                                            <span
                                                onClick={() => setCaptionExpanded(p => !p)}
                                                style={{
                                                    color: "#60a5fa",
                                                    fontSize: "12px",
                                                    cursor: "pointer",
                                                    fontWeight: 500,
                                                    display: "block",
                                                    marginTop: 4
                                                }}
                                            >
                                                {captionExpanded ? "see less" : "see more"}
                                            </span>
                                        )}
                                </div>
                            )}
                        </div>
                    ) : (
                        /* ✅ YOUR EXISTING PREVIEW (NO CHANGE) */
                        <div style={{ padding: "12px 16px" }}>

                            {/* FACEBOOK */}
                            {adFormat === "facebook" && (
                                <div style={{ border: "0.5px solid #e5e7eb", borderRadius: "10px", overflow: "hidden", backgroundColor: "#fff", fontFamily: "sans-serif" }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px 8px" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <div style={{ width: 34, height: 34, borderRadius: "50%", backgroundColor: "#e8523a", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px", fontWeight: 600, color: "#fff", flexShrink: 0 }}>{initials}</div>
                                            <div>
                                                <p style={{ margin: 0, fontSize: "13px", fontWeight: 600, color: "#111827" }}>{formData.name || "Your Business"}</p>
                                                <p style={{ margin: 0, fontSize: "11px", color: "#6b7280" }}>Ad · 🌐</p>
                                            </div>
                                        </div>
                                        <MoreHorizontal size={15} color="#6b7280" />
                                    </div>

                                    <div style={{ position: "relative" }}>
                                        {/* ✅ ONLY CHANGE: play video if mediaType is video, else keep mediaEl */}
                                        {mediaType === "video" ? (
                                            <video
                                                key={safeMedia}
                                                src={safeMedia}
                                                controls
                                                autoPlay
                                                muted
                                                loop
                                                playsInline
                                                style={{
                                                    width: "100%",
                                                    height: "170px",
                                                    objectFit: "cover",
                                                    display: "block",
                                                    backgroundColor: "#000"
                                                }}
                                            />
                                        ) : (
                                            mediaEl("270px")
                                        )}
                                        <button onClick={prevFmt} style={navArrow("left")}><ChevronLeft size={14} color="#fff" /></button>
                                        <button onClick={nextFmt} style={navArrow("right")}><ChevronRight size={14} color="#fff" /></button>
                                        {dots(6)}
                                    </div>

                                    {/* CTA Row */}
                                    {(() => {
                                        const cta = getCTAButton(14, "#111827");
                                        const baseStyle = { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", borderTop: "0.5px solid #e5e7eb" };
                                        const btnBase = { borderRadius: "6px", padding: "6px 12px", fontSize: "12px", fontWeight: 600, cursor: "pointer", display: "flex", alignItems: "center", gap: 5 };
                                        if (cta.isWebsite) return (
                                            <div style={baseStyle}>
                                                <div><p style={{ margin: 0, fontSize: "10px", color: "#9ca3af" }}>fb.com</p><p style={{ margin: 0, fontSize: "12px", fontWeight: 600, color: "#111827" }}>www.fb.com</p></div>
                                                <button
                                                    style={{
                                                        ...btnBase,
                                                        backgroundColor: cta.bg,
                                                        color: cta.color,
                                                        border: cta.border || "none"
                                                    }}
                                                >
                                                    {cta.icon && <cta.icon size={14} />}
                                                    {cta.label}
                                                </button>
                                            </div>
                                        );
                                        return (
                                            <div style={baseStyle}>
                                                <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>{formData.name || "Your Business"}</span>
                                                <button style={{ ...btnBase, backgroundColor: cta.bg, color: cta.color, border: cta.border || "none" }}>  {cta.icon}
                                                    {ctaLabel || "Visit Page"}   </button>
                                            </div>
                                        );
                                    })()}
                                    {(formData.mediaDescriptions?.image || formData.mediaDescriptions?.video) && (
                                        <div style={{ padding: "0 12px 8px" }}>
                                            <p style={{ margin: 0, fontSize: "12px", color: "#111827", lineHeight: 1.5 }}>
                                                {(() => { const text = formData.mediaDescriptions?.image || formData.mediaDescriptions?.video; return captionExpanded || text.length <= 80 ? text : `${text.slice(0, 80)}...`; })()}
                                            </p>
                                            {(formData.mediaDescriptions?.image || formData.mediaDescriptions?.video).length > 80 && (
                                                <span onClick={() => setCaptionExpanded(p => !p)} style={{ color: "#185FA5", fontSize: "11px", cursor: "pointer", fontWeight: 500, display: "block", marginTop: 2 }}>
                                                    {captionExpanded ? "see less" : "see more"}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    <div style={{ display: "flex", borderTop: "0.5px solid #e5e7eb" }}>
                                        {[{ icon: <ThumbsUp size={13} />, label: "Like" }, { icon: <MessageCircle size={13} />, label: "Comment" }, { icon: <Share2 size={13} />, label: "Share" }].map(btn => (
                                            <button key={btn.label} style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", gap: 5, padding: "7px 0", fontSize: "12px", color: "#6b7280", background: "none", border: "none", cursor: "pointer" }}>{btn.icon} {btn.label}</button>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {/* INSTAGRAM FEED */}
                            {adFormat === "instagram_feed" && (
                                <div style={{ border: "0.5px solid #e5e7eb", borderRadius: "10px", overflow: "hidden", backgroundColor: "#fff", fontFamily: "sans-serif" }}>
                                    <div style={{ position: "relative" }}>
                                        {/* ✅ ONLY CHANGE: play video if mediaType is video, else keep mediaEl */}
                                        {mediaType === "video" ? (
                                            <video
                                                key={safeMedia}
                                                src={safeMedia}
                                                controls
                                                autoPlay
                                                muted
                                                loop
                                                playsInline
                                                style={{
                                                    width: "100%",
                                                    height: "220px",
                                                    objectFit: "cover",
                                                    display: "block",
                                                    backgroundColor: "#000"
                                                }}
                                            />
                                        ) : (
                                            mediaEl("220px")
                                        )}
                                        <button onClick={prevFmt} style={navArrow("left")}><ChevronLeft size={14} color="#fff" /></button>
                                        <button onClick={nextFmt} style={navArrow("right")}><ChevronRight size={14} color="#fff" /></button>
                                        {dots(6)}
                                    </div>
                                    <div style={{ padding: "10px 12px", borderBottom: "0.5px solid #e5e7eb" }}>
                                        {(() => {
                                            const cta = getCTAButton(14);
                                            return (
                                                <button style={{ width: "100%", padding: "10px 14px", fontSize: "13px", fontWeight: 600, backgroundColor: "#fff", border: "1px solid #d1d5db", borderRadius: "8px", cursor: "pointer", color: "#111827", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>{cta.icon}<span>{cta.label}</span></div>
                                                    <ChevronRight size={15} color="#111827" />
                                                </button>
                                            );
                                        })()}
                                    </div>
                                    {(formData.mediaDescriptions?.image || formData.mediaDescriptions?.video) && (
                                        <div style={{ padding: "0 12px 8px" }}>
                                            <p style={{ margin: 0, fontSize: "12px", color: "#111827", lineHeight: 1.5 }}>
                                                {(() => { const text = formData.mediaDescriptions?.image || formData.mediaDescriptions?.video; return captionExpanded || text.length <= 80 ? text : `${text.slice(0, 80)}...`; })()}
                                            </p>
                                            {(formData.mediaDescriptions?.image || formData.mediaDescriptions?.video).length > 80 && (
                                                <span onClick={() => setCaptionExpanded(p => !p)} style={{ color: "#185FA5", fontSize: "11px", cursor: "pointer", fontWeight: 500, display: "block", marginTop: 2 }}>
                                                    {captionExpanded ? "see less" : "see more"}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    <div style={{ padding: "8px 12px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></svg>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" /><polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" /></svg>
                                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13" /><polygon points="22 2 15 22 11 13 2 9 22 2" /></svg>
                                        </div>
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111827" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" /></svg>
                                    </div>
                                    <div style={{ padding: "4px 12px 8px" }}>
                                        <span style={{ fontSize: "10px", color: "#6b7280", backgroundColor: "#f1f5f9", borderRadius: "4px", padding: "1px 5px" }}>Ad</span>
                                    </div>
                                </div>
                            )}

                            {/* INSTAGRAM STORY */}
                            {adFormat === "instagram_story" && (
                                <div style={{ border: "0.5px solid #e5e7eb", borderRadius: "10px", overflow: "hidden", backgroundColor: "#000", fontFamily: "sans-serif", position: "relative" }}>
                                    {/* ✅ ONLY CHANGE: play video if mediaType is video, else keep mediaEl */}
                                    {mediaType === "video" ? (
                                        <video
                                            key={safeMedia}
                                            src={safeMedia}
                                            controls
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            style={{
                                                width: "100%",
                                                height: "340px",
                                                objectFit: "cover",
                                                display: "block",
                                                backgroundColor: "#000"
                                            }}
                                        />
                                    ) : (
                                        mediaEl("340px")
                                    )}
                                    <button onClick={prevFmt} style={navArrow("left")}><ChevronLeft size={14} color="#fff" /></button>
                                    <button onClick={nextFmt} style={navArrow("right")}><ChevronRight size={14} color="#fff" /></button>
                                    {dots(60)}
                                    <div style={{ position: "absolute", top: 12, left: 12, display: "flex", alignItems: "center", gap: 8 }}>
                                        <div style={{ width: 30, height: 30, borderRadius: "50%", backgroundColor: "#e8523a", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: 600, color: "#fff", border: "2px solid #fff" }}>{initials}</div>
                                        <div>
                                            <p style={{ margin: 0, fontSize: "11px", fontWeight: 600, color: "#fff" }}>{formData.name || "yourbusiness"}</p>
                                            <p style={{ margin: 0, fontSize: "10px", color: "rgba(255,255,255,0.7)" }}>Sponsored</p>
                                        </div>
                                    </div>
                                    <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "12px", background: "linear-gradient(transparent, rgba(0,0,0,0.7))" }}>
                                        {(() => {
                                            const cta = getCTAButton(14, "#111827");
                                            return (
                                                <button style={{ width: "100%", padding: "10px", fontSize: "13px", fontWeight: 600, backgroundColor: "#fff", border: "none", borderRadius: "8px", cursor: "pointer", color: "#111827", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                                                    {cta.icon}{cta.label}
                                                </button>
                                            );
                                        })()}
                                    </div>
                                    {captionText && (
                                        <div style={{ padding: "0 12px 8px" }}>
                                            <p style={{
                                                margin: 0,
                                                fontSize: "12px",
                                                color: "#fff",
                                                lineHeight: 1.5
                                            }}>
                                                {captionExpanded || captionText.length <= 80
                                                    ? captionText
                                                    : `${captionText.slice(0, 80)}...`}
                                            </p>
                                            {captionText.length > 80 && (
                                                <span
                                                    onClick={() => setCaptionExpanded(prev => !prev)}
                                                    style={{
                                                        color: "#60a5fa",
                                                        fontSize: "11px",
                                                        cursor: "pointer",
                                                        fontWeight: 500,
                                                        display: "block",
                                                        marginTop: 2
                                                    }}
                                                >
                                                    {captionExpanded ? "see less" : "see more"}
                                                </span>
                                            )}
                                        </div>
                                    )}
                                    {/* 🔥 RIGHT SIDE REELS ICONS */}
                                    {/* 🔥 RIGHT SIDE ICONS (REELS STYLE) */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            bottom: "80px",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            gap: "16px",
                                            zIndex: 2,
                                        }}
                                    >
                                        {/* ❤️ LIKE */}
                                        <div style={{ textAlign: "center", cursor: "pointer" }}>
                                            <div style={{ background: "rgba(0,0,0,0.4)", padding: "8px", borderRadius: "50%" }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                                                </svg>
                                            </div>
                                            <span style={{ fontSize: "10px", color: "#fff" }}>1.2K</span>
                                        </div>
                                        {/* 💬 COMMENT */}
                                        <div style={{ textAlign: "center", cursor: "pointer" }}>
                                            <div style={{ background: "rgba(0,0,0,0.4)", padding: "8px", borderRadius: "50%" }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                                                </svg>
                                            </div>
                                            <span style={{ fontSize: "10px", color: "#fff" }}>340</span>
                                        </div>
                                        {/* 🔁 SHARE */}
                                        <div style={{ textAlign: "center", cursor: "pointer" }}>
                                            <div style={{ background: "rgba(0,0,0,0.4)", padding: "8px", borderRadius: "50%" }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                    <polyline points="17 1 21 5 17 9" />
                                                    <path d="M3 11V9a4 4 0 0 1 4-4h14" />
                                                    <polyline points="7 23 3 19 7 15" />
                                                    <path d="M21 13v2a4 4 0 0 1-4 4H3" />
                                                </svg>
                                            </div>
                                            <span style={{ fontSize: "10px", color: "#fff" }}>Share</span>
                                        </div>
                                        {/* ✈ SEND */}
                                        <div style={{ textAlign: "center", cursor: "pointer" }}>
                                            <div style={{ background: "rgba(0,0,0,0.4)", padding: "8px", borderRadius: "50%" }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="22" y1="2" x2="11" y2="13" />
                                                    <polygon points="22 2 15 22 11 13 2 9 22 2" />
                                                </svg>
                                            </div>
                                        </div>
                                        {/* 🔖 SAVE */}
                                        <div style={{ textAlign: "center", cursor: "pointer" }}>
                                            <div style={{ background: "rgba(0,0,0,0.4)", padding: "8px", borderRadius: "50%" }}>
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    )}
                </>
            )}

            {/* Empty state */}
            {
                !formData.goal && !hasMedia && (
                    <div style={{ padding: "32px 16px", textAlign: "center" }}>
                        <div style={{ width: 44, height: 44, borderRadius: "50%", backgroundColor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 10px" }}>
                            <ImageIcon size={20} color="#9ca3af" />
                        </div>
                        <p style={{ margin: 0, fontSize: "13px", color: "#6b7280", fontWeight: 500 }}>Nothing selected yet</p>
                        <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#9ca3af" }}>Your selections will appear here</p>
                    </div>
                )
            }


            {showPayment && (

                (formData.goal === "discount" &&
                    formData.subGoal !== "coupons")
                    ? (

                        /* 🔹 DISCOUNT (keep your existing code as is) */
                        <div>

                            {(() => {
                                const start = new Date(startDate);
                                const end = new Date(endDate);

                                const totalDays =
                                    startDate && endDate
                                        ? Math.ceil(
                                            (end.getTime() - start.getTime()) /
                                            (1000 * 60 * 60 * 24)
                                        ) + 1
                                        : 1;
                                // ✅ Billing config
                                const menuChargePerItem =
                                    billingData?.menuChargePerItem || 0;

                                // ✅ Discount config
                                const discountConfig =
                                    formData?.goalConfig?.discount || {};

                                const discountType =
                                    discountConfig?.discountTarget ||
                                    discountConfig?.discountType;

                                // ✅ Menu Items
                                const allMenuItems =
                                    menuItems || [];

                                const selectedMenuItems =
                                    discountConfig?.selectedItems || [];

                                // ✅ Count
                                const totalItems =
                                    discountType === "overall"
                                        ? allMenuItems.length
                                        : selectedMenuItems.length;

                                // ✅ Charges
                                const menuCharges =
                                    totalItems *
                                    menuChargePerItem *
                                    totalDays;

                                // ✅ SUB TOTAL
                                const subTotal =
                                    menuCharges;

                                // ✅ GST
                                const gst =
                                    subTotal * 0.18;

                                // ✅ TOTAL
                                const total =
                                    subTotal + gst;

                                // ✅ FINAL TOTAL
                                const finalTotal =
                                    couponApplied
                                        ? total - couponDiscount
                                        : total;

                                return (
                                    <>
                                        <div
                                            style={{
                                                marginTop: "0px",
                                                padding: "14px 16px",
                                                borderRadius: "12px",
                                                background: "#ffffff",
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                                border: "1px solid #e5e7eb",
                                                width: "94%",
                                                marginLeft: "auto",
                                                marginRight: "auto"
                                            }}
                                        >

                                            <p
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 700,
                                                    marginBottom: "10px",
                                                    color: "#1e3a8a",
                                                    textAlign: "center"
                                                }}
                                            >
                                                🧾 Discount Billing Summary
                                            </p>

                                            {/* ✅ Discount Type */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    marginBottom: "6px",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151"
                                                    }}
                                                >
                                                    Discount Type
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: "11px",
                                                        fontWeight: 600,
                                                        backgroundColor:
                                                            discountType === "overall"
                                                                ? "#e0f2fe"
                                                                : "#fef3c7",
                                                        color:
                                                            discountType === "overall"
                                                                ? "#0369a1"
                                                                : "#92400e",
                                                        borderRadius: "5px",
                                                        padding: "2px 8px"
                                                    }}
                                                >
                                                    {
                                                        discountType === "overall"
                                                            ? "🍽️ Overall Menu"
                                                            : "🎯 Specific Items"
                                                    }
                                                </span>
                                            </div>

                                            {/* ✅ Items Count */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    marginBottom: "8px",
                                                    // gap: "142px",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151"
                                                    }}
                                                >
                                                    {
                                                        discountType === "overall"
                                                            ? "All Menu Items"
                                                            : "Selected Items"
                                                    }
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        fontWeight: 600,
                                                        color: "#374151"
                                                    }}
                                                >
                                                    {totalItems} items × ₹
                                                    {menuChargePerItem}
                                                </span>
                                            </div>

                                            {/* ✅ Selected Items */}
                                            {
                                                discountType !== "overall" &&
                                                selectedMenuItems.length > 0 && (

                                                    <div
                                                        style={{
                                                            background: "#f8fafc",
                                                            borderRadius: "8px",
                                                            padding: "8px 10px",
                                                            marginBottom: "10px",
                                                            fontSize: "11px",
                                                            color: "#6b7280"
                                                        }}
                                                    >

                                                        {
                                                            selectedMenuItems.map(
                                                                (item, i) => (
                                                                    <div
                                                                        key={i}
                                                                        style={{
                                                                            marginBottom:
                                                                                "2px"
                                                                        }}
                                                                    >
                                                                        • {item.name} (
                                                                        {item.category}
                                                                        )
                                                                    </div>
                                                                )
                                                            )
                                                        }

                                                    </div>
                                                )
                                            }

                                            {/* ✅ SUB TOTAL */}


                                            {/* ✅ APPLY COUPON */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    width: "100%",
                                                    marginBottom: "12px",
                                                }}
                                            >
                                                {/* Input */}
                                                <input
                                                    type="text"
                                                    placeholder="Enter coupon"
                                                    value={formData.couponCode || ""}
                                                    onChange={(e) =>
                                                        onInputChange("couponCode", e.target.value)
                                                    }
                                                    style={{
                                                        width: "180px",
                                                        flex: "1 1 auto",
                                                        height: "36px",
                                                        borderRadius: "10px",
                                                        border: "1.5px solid #f97316",
                                                        outline: "none",
                                                        padding: "0 12px",
                                                        fontSize: "12px",
                                                        color: "#000",
                                                        boxSizing: "border-box",
                                                    }}
                                                />

                                                {/* Apply Button */}
                                                <Button
                                                    variant="contained"
                                                    onClick={applyCoupon}
                                                    sx={{
                                                        flexShrink: 0,
                                                        minWidth: "80px",
                                                        height: "36px",
                                                        borderRadius: "10px",
                                                        textTransform: "none",
                                                        background: "#f97316",
                                                        color: "#fff",
                                                        boxShadow: "none",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        "&:hover": {
                                                            background: "#ea580c",
                                                            boxShadow: "none",
                                                        },
                                                    }}
                                                >
                                                    Apply
                                                </Button>

                                                {/* Coupon Value */}
                                                <span
                                                    style={{
                                                        flexShrink: 0,
                                                        fontSize: "13px",
                                                        fontWeight: "600",
                                                        color: "#16a34a",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    ₹{couponDiscount || 0}
                                                </span>
                                            </div>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    Sub Total
                                                </span>

                                                <span
                                                    style={{
                                                        fontWeight: 700,
                                                        color: "#1e40af"
                                                    }}
                                                >
                                                    ₹ {subTotal.toFixed(2)}
                                                </span>
                                            </div>
                                            {/* ✅ GST */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    // gap: "217px",
                                                    marginBottom: "8px",
                                                    fontWeight: "bold"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151"
                                                    }}
                                                >
                                                    GST (18%)
                                                </span>

                                                <span
                                                    style={{
                                                        fontWeight: 600,
                                                        color: "#1e40af"
                                                    }}
                                                >
                                                    ₹ {gst.toFixed(2)}
                                                </span>
                                            </div>

                                            {/* ✅ COUPON DISCOUNT */}
                                            {
                                                couponApplied && (

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent:
                                                                "space-between",
                                                            marginBottom: "8px"
                                                        }}
                                                    >

                                                        <span
                                                            style={{
                                                                fontSize: "12px",
                                                                color: "#16a34a",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            Coupon Discount
                                                        </span>

                                                        <span
                                                            style={{
                                                                fontWeight: 700,
                                                                color: "#16a34a"
                                                            }}
                                                        >
                                                            - ₹ {
                                                                couponDiscount.toFixed(2)
                                                            }
                                                        </span>

                                                    </div>
                                                )
                                            }

                                            {/* ✅ GRAND TOTAL */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                    marginTop: "8px",
                                                    paddingTop: "8px",
                                                    borderTop:
                                                        "1px dashed #93c5fd"
                                                }}
                                            >

                                                <span
                                                    style={{
                                                        fontWeight: 700,
                                                        color: "#1e3a8a"
                                                    }}
                                                >
                                                    Grand Total
                                                </span>

                                                <span
                                                    style={{
                                                        fontWeight: 800,
                                                        color: "#2563eb"
                                                    }}
                                                >
                                                    ₹ {
                                                        couponApplied
                                                            ? finalTotal.toFixed(2)
                                                            : total.toFixed(2)
                                                    }
                                                </span>

                                            </div>

                                            {/* ✅ PAY NOW */}
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                onClick={handlePayment}
                                                sx={{
                                                    mt: 2,
                                                    borderRadius: "10px",
                                                    fontWeight: 600,
                                                    backgroundColor: "#2563eb",
                                                    "&:hover": {
                                                        backgroundColor:
                                                            "#1d4ed8"
                                                    }
                                                }}
                                            >
                                                Pay Now ₹  {finalTotal <= 0
                                                    ? "Create Campaign"
                                                    : `${finalTotal.toFixed(2)}`}
                                            </Button>

                                        </div>
                                    </>
                                );
                            })()}
                        </div>


                    ) : formData.subGoal === "coupons" ? (

                        /* 🔹 COUPONS (keep your existing code as is) */
                        <div>


                            {(() => {

                                const investment =
                                    Number(formData.investment || 0);

                                const couponCharge =
                                    Number(
                                        billingData?.couponCharge || 0
                                    );

                                const baseAmount =
                                    investment + couponCharge;

                                const gst =
                                    baseAmount * 0.18;

                                const total =
                                    baseAmount + gst;

                                // ✅ FINAL TOTAL AFTER COUPON
                                const finalTotal =
                                    couponApplied
                                        ? total - couponDiscount
                                        : total;

                                return (
                                    <>
                                        <div
                                            style={{
                                                marginTop: "0px",
                                                padding: "14px 16px",
                                                borderRadius: "12px",
                                                background: "#ffffff",
                                                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                                border: "1px solid #e5e7eb",
                                                width: "94%",
                                                marginLeft: "auto",
                                                marginRight: "auto"
                                            }}
                                        >

                                            <p
                                                style={{
                                                    fontSize: "14px",
                                                    fontWeight: 700,
                                                    marginBottom: "10px",
                                                    color: "#1e3a8a",
                                                    textAlign: "center"
                                                }}
                                            >
                                                💳 Coupon Summary
                                            </p>

                                            {/* ✅ BUDGET */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    Budget
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        color: "#1e40af"
                                                    }}
                                                >
                                                    ₹ {investment.toFixed(2)}
                                                </span>
                                            </div>

                                            {/* ✅ COUPON CHARGE */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    Coupon Charges
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        color: "#1e40af"
                                                    }}
                                                >
                                                    ₹ {couponCharge.toFixed(2)}
                                                </span>
                                            </div>

                                            {/* ✅ SUB TOTAL */}


                                            {/* ✅ APPLY COUPON */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "16px",
                                                    width: "100%",
                                                    marginBottom: "12px",
                                                }}
                                            >
                                                {/* Coupon Input */}
                                                <input
                                                    type="text"
                                                    placeholder="Enter coupon"
                                                    value={formData.couponCode || ""}
                                                    onChange={(e) =>
                                                        onInputChange("couponCode", e.target.value)
                                                    }
                                                    style={{
                                                        width: "182px", // Decreased width
                                                        height: "36px",
                                                        borderRadius: "10px",
                                                        border: "1.5px solid #f97316",
                                                        outline: "none",
                                                        padding: "0 12px",
                                                        fontSize: "12px",
                                                        color: "#000",
                                                        boxSizing: "border-box",
                                                        flexShrink: 0,
                                                    }}
                                                />

                                                {/* Apply Button */}
                                                <Button
                                                    variant="contained"
                                                    onClick={applyCoupon}
                                                    sx={{
                                                        minWidth: "74px",
                                                        height: "36px",
                                                        borderRadius: "10px",
                                                        textTransform: "none",
                                                        background: "#f97316",
                                                        color: "#fff",
                                                        boxShadow: "none",
                                                        fontWeight: 600,
                                                        fontSize: "12px",
                                                        flexShrink: 0,
                                                        "&:hover": {
                                                            background: "#ea580c",
                                                            boxShadow: "none",
                                                        },
                                                    }}
                                                >
                                                    Apply
                                                </Button>

                                                {/* Discount */}
                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: "600",
                                                        color: "#16a34a",
                                                        whiteSpace: "nowrap",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    ₹{couponDiscount || 0}
                                                </span>
                                            </div>


                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    Sub Total
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        color: "#1e40af"
                                                    }}
                                                >
                                                    ₹ {baseAmount.toFixed(2)}
                                                </span>
                                            </div>
                                            {/* ✅ GST */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginBottom: "8px"
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#374151",
                                                        fontWeight: "bold"
                                                    }}
                                                >
                                                    GST (18%)
                                                </span>

                                                <span
                                                    style={{
                                                        fontSize: "13px",
                                                        fontWeight: 700,
                                                        color: "#1e40af"
                                                    }}
                                                >
                                                    ₹ {gst.toFixed(2)}
                                                </span>
                                            </div>

                                            {/* ✅ COUPON DISCOUNT */}
                                            {
                                                couponApplied && (

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            marginBottom: "8px"
                                                        }}
                                                    >

                                                        <span
                                                            style={{
                                                                fontSize: "12px",
                                                                color: "#16a34a",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            Coupon Discount
                                                        </span>

                                                        <span
                                                            style={{
                                                                fontSize: "13px",
                                                                fontWeight: 700,
                                                                color: "#16a34a"
                                                            }}
                                                        >
                                                            - ₹ {couponDiscount.toFixed(2)}
                                                        </span>

                                                    </div>
                                                )
                                            }

                                            {/* ✅ GRAND TOTAL */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    marginTop: "8px",
                                                    paddingTop: "8px",
                                                    borderTop: "1px dashed #93c5fd",
                                                    color: "#000"
                                                }}
                                            >

                                                <strong>
                                                    Grand Total
                                                </strong>

                                                <strong
                                                    style={{
                                                        color: "#16a34a",
                                                        fontSize: "16px"
                                                    }}
                                                >
                                                    ₹ {
                                                        couponApplied
                                                            ? finalTotal.toFixed(2)
                                                            : total.toFixed(2)
                                                    }
                                                </strong>

                                            </div>

                                            {/* ✅ PAY NOW */}
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                onClick={handlePayment}
                                                sx={{
                                                    mt: 2,
                                                    borderRadius: "10px",
                                                    fontWeight: 600,
                                                    backgroundColor: "#2563eb",
                                                    "&:hover": {
                                                        backgroundColor: "#1d4ed8"
                                                    }
                                                }}
                                            >
                                                Pay Now ₹{
                                                    couponApplied
                                                        ? finalTotal.toFixed(2)
                                                        : total.toFixed(2)
                                                }
                                            </Button>

                                        </div>
                                    </>
                                );
                            })()}
                        </div>

                    ) : formData.goal === "branding" &&
                        formData.mediums?.includes("digital") ? (

                        /* 🔹 BRANDING + DIGITAL */
                        <div>
                            {(() => {
                                const selectedScreens = formData.placements || [];
                                const screenCount = selectedScreens.length;

                                const investment = Number(formData.investment || 0);
                                const gst = investment * 0.18;
                                const total = investment + gst;
                                return (
                                    <div>
                                        {(() => {

                                            const selectedScreens =
                                                formData.placements || [];

                                            const screenCount =
                                                selectedScreens.length;

                                            const investment =
                                                Number(
                                                    formData.investment || 0
                                                );

                                            const gst =
                                                investment * 0.18;

                                            const total =
                                                investment + gst;
                                            const finalTotal =
                                                total - couponDiscount;
                                            return (

                                                <div
                                                    style={{
                                                        marginTop: "14px",
                                                        padding: "14px 16px",
                                                        borderRadius: "12px",
                                                        background: "#ffffff",
                                                        boxShadow:
                                                            "0 4px 12px rgba(0,0,0,0.08)",
                                                        border:
                                                            "1px solid #e5e7eb",
                                                        width: "100%",
                                                        marginLeft: "auto",
                                                        marginRight: "auto"
                                                    }}
                                                >

                                                    {/* ✅ TITLE */}
                                                    <p
                                                        style={{
                                                            fontSize: "14px",
                                                            fontWeight: 700,
                                                            marginBottom: "14px",
                                                            color: "#1e3a8a",
                                                            textAlign: "center"
                                                        }}
                                                    >
                                                        📺 Digital Branding Summary
                                                    </p>

                                                    {/* ✅ INVESTMENT */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            marginBottom: "10px",
                                                            gap: "140px"
                                                        }}
                                                    >

                                                        <span
                                                            style={{
                                                                fontSize: "13px",
                                                                color: "#374151",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            Investment × {screenCount} Screens
                                                        </span>

                                                        <span
                                                            style={{
                                                                fontSize: "14px",
                                                                fontWeight: 700,
                                                                color: "#1e40af"
                                                            }}
                                                        >
                                                            ₹ {investment}
                                                        </span>

                                                    </div>

                                                    {/* ✅ APPLY COUPON */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "15px",
                                                            width: "100%",
                                                            flexWrap: "wrap",
                                                        }}
                                                    >


                                                        {/* Input */}
                                                        <input
                                                            type="text"
                                                            placeholder="Enter coupon"
                                                            value={formData.couponCode || ""}
                                                            onChange={(e) =>
                                                                onInputChange("couponCode", e.target.value)
                                                            }
                                                            style={{
                                                                maxWidth: "170px",
                                                                flex: 1,
                                                                height: "36px",
                                                                borderRadius: "12px",
                                                                border: "1.5px solid #f97316",
                                                                outline: "none",
                                                                padding: "0 12px",
                                                                fontSize: "13px",
                                                                color: "#000",
                                                                minWidth: "150px",
                                                                boxSizing: "border-box",
                                                            }}
                                                        />

                                                        {/* Apply Button */}
                                                        <Button
                                                            variant="contained"
                                                            onClick={applyCoupon}
                                                            sx={{
                                                                height: "36px",
                                                                minWidth: "85px",
                                                                borderRadius: "12px",
                                                                textTransform: "none",
                                                                background: "#f97316",
                                                                color: "#fff",
                                                                fontWeight: 600,
                                                                fontSize: "13px",
                                                                boxShadow: "none",
                                                                "&:hover": {
                                                                    background: "#ea580c",
                                                                    boxShadow: "none",
                                                                },
                                                            }}
                                                        >
                                                            Apply
                                                        </Button>

                                                        {/* Coupon Value */}
                                                        <span
                                                            style={{
                                                                fontSize: "13px",
                                                                fontWeight: "600",
                                                                color: "#16a34a",
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            ₹ {couponDiscount || 0}
                                                        </span>
                                                    </div>

                                                    {/* ✅ SUB TOTAL */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            paddingTop: "10px",
                                                            justifyContent: "space-between",
                                                        }}
                                                    >

                                                        <strong
                                                            style={{
                                                                fontSize: "14px",
                                                                color: "#374151"
                                                            }}
                                                        >
                                                            Sub Total
                                                        </strong>

                                                        <strong
                                                            style={{
                                                                fontSize: "15px",
                                                                fontWeight: 700,
                                                                color: "#1e40af"
                                                            }}
                                                        >
                                                            ₹ {investment.toFixed(2)}
                                                        </strong>

                                                    </div>

                                                    {/* ✅ GST */}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            marginBottom: "10px"
                                                        }}
                                                    >

                                                        <span
                                                            style={{
                                                                fontSize: "13px",
                                                                color: "#374151",
                                                                fontWeight: "bold"
                                                            }}
                                                        >
                                                            GST (18%)
                                                        </span>

                                                        <span
                                                            style={{
                                                                fontSize: "14px",
                                                                fontWeight: 700,
                                                                color: "#1e40af"
                                                            }}
                                                        >
                                                            ₹ {gst.toFixed(2)}
                                                        </span>

                                                    </div>

                                                    {/* ✅ COUPON DISCOUNT */}
                                                    {
                                                        couponApplied && (

                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    marginBottom: "10px"
                                                                }}
                                                            >

                                                                <span
                                                                    style={{
                                                                        fontSize: "13px",
                                                                        color: "#16a34a",
                                                                        fontWeight: "bold"
                                                                    }}
                                                                >
                                                                    Coupon Discount
                                                                </span>

                                                                <span
                                                                    style={{
                                                                        fontSize: "14px",
                                                                        fontWeight: 700,
                                                                        color: "#16a34a"
                                                                    }}
                                                                >
                                                                    - ₹ {couponDiscount.toFixed(2)}
                                                                </span>

                                                            </div>
                                                        )
                                                    }

                                                    {/* ✅ GRAND TOTAL */}
                                                    <div
                                                        style={{
                                                            marginTop: "16px",
                                                            paddingTop: "14px",
                                                            borderTop:
                                                                "1px dashed #cbd5e1"
                                                        }}
                                                    >

                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent:
                                                                    "space-between",
                                                                alignItems: "center"
                                                            }}
                                                        >

                                                            <span
                                                                style={{
                                                                    fontSize: "16px",
                                                                    fontWeight: 700,
                                                                    color: "#111827"
                                                                }}
                                                            >
                                                                Grand Total
                                                            </span>

                                                            <span
                                                                style={{
                                                                    fontSize: "20px",
                                                                    fontWeight: 800,
                                                                    color: "#16a34a"
                                                                }}
                                                            >
                                                                ₹ {
                                                                    couponApplied
                                                                        ? finalTotal.toFixed(2)
                                                                        : total.toFixed(2)
                                                                }
                                                            </span>

                                                        </div>

                                                    </div>

                                                    {/* ✅ PAY NOW BUTTON */}
                                                    <Button
                                                        fullWidth
                                                        variant="contained"
                                                        onClick={handlePayment}
                                                        sx={{
                                                            mt: 2,
                                                            height: "46px",
                                                            borderRadius: "12px",
                                                            textTransform: "none",
                                                            fontSize: "15px",
                                                            fontWeight: 700
                                                        }}
                                                    >
                                                        Pay Now ₹{
                                                            couponApplied
                                                                ? finalTotal.toFixed(2)
                                                                : total.toFixed(2)
                                                        }
                                                    </Button>

                                                </div>
                                            );

                                        })()}
                                    </div>
                                );
                            })()}
                        </div>

                    ) : Number(formData.investment) > 0 ? (

                        /* 🔹 NORMAL */
                        <div>


                            {(() => {
                                const investment = formData.investment || 0;
                                const gst = investment * 0.18;
                                const total = investment + gst;
                                // ✅ FINAL TOTAL AFTER COUPON
                                const finalTotal =
                                    couponApplied
                                        ? total - couponDiscount
                                        : total;

                                return (
                                    <>
                                        <div style={{
                                            marginTop: "0px",
                                            padding: "14px 16px",
                                            borderRadius: "12px",
                                            background: "#ffffff",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                            border: "1px solid #e5e7eb",
                                            width: "94%",
                                            marginLeft: "auto",
                                            marginRight: "auto"
                                        }}>

                                            <p style={{
                                                fontSize: "14px",
                                                fontWeight: 700,
                                                marginBottom: "10px",
                                                color: "#1e3a8a",
                                                textAlign: "center"
                                            }}>
                                                💳 Payment Summary
                                            </p>

                                            {/* ✅ BUDGET */}
                                            <div style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                // gap: "240px",
                                                marginBottom: "6px"
                                            }}>
                                                <span style={{
                                                    fontSize: "12px",
                                                    color: "#374151",
                                                    fontWeight: "bold"
                                                }}>
                                                    Budget
                                                </span>

                                                <span style={{
                                                    fontSize: "13px",
                                                    fontWeight: 700,
                                                    color: "#1e40af"
                                                }}>
                                                    ₹ {formData.investment || 0}
                                                </span>
                                            </div>

                                            {(() => {

                                                const investment =
                                                    Number(formData.investment || 0);

                                                const gst =
                                                    investment * 0.18;

                                                const total =
                                                    investment + gst;

                                                return (
                                                    <>

                                                        {/* ✅ APPLY COUPON */}
                                                        {/* ✅ APPLY COUPON */}
                                                        <div
                                                            style={{
                                                                marginTop: "12px",
                                                                marginBottom: "12px"
                                                            }}
                                                        >


                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "10px",
                                                                    width: "100%"
                                                                }}
                                                            >
                                                                {/* Coupon Input */}
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter Coupon"
                                                                    value={formData.couponCode || ""}
                                                                    onChange={(e) =>
                                                                        onInputChange("couponCode", e.target.value)
                                                                    }
                                                                    style={{
                                                                        flex: 1,
                                                                        minWidth: "120px",
                                                                        height: "38px",
                                                                        borderRadius: "10px",
                                                                        border: "1.5px solid #f97316",
                                                                        outline: "none",
                                                                        padding: "0 12px",
                                                                        fontSize: "13px",
                                                                        color: "#111827",
                                                                        background: "#fff"
                                                                    }}
                                                                />

                                                                {/* Apply Button */}
                                                                <Button
                                                                    onClick={applyCoupon}
                                                                    variant="contained"
                                                                    sx={{
                                                                        minWidth: "80px",
                                                                        height: "38px",
                                                                        borderRadius: "10px",
                                                                        textTransform: "none",
                                                                        background: "#f97316",
                                                                        fontWeight: 600,
                                                                        fontSize: "13px",
                                                                        boxShadow: "none",
                                                                        flexShrink: 0,
                                                                        "&:hover": {
                                                                            background: "#ea580c",
                                                                            boxShadow: "none"
                                                                        }
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>

                                                                {/* Discount Value */}
                                                                <div
                                                                    style={{
                                                                        minWidth: "75px",
                                                                        height: "38px",
                                                                        borderRadius: "10px",
                                                                        background: "#ECFDF5",
                                                                        border: "1px solid #BBF7D0",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        fontSize: "13px",
                                                                        fontWeight: 700,
                                                                        color: "#16A34A",
                                                                        flexShrink: 0
                                                                    }}
                                                                >
                                                                    {couponApplied
                                                                        ? `-₹${couponDiscount.toFixed(0)}`
                                                                        : "-₹0"}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* ✅ SUB TOTAL */}
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            // gap: "220px",
                                                            marginBottom: "6px"
                                                        }}>
                                                            <span style={{
                                                                fontSize: "12px",
                                                                color: "#374151",
                                                                fontWeight: "bold"
                                                            }}>
                                                                Sub Total
                                                            </span>

                                                            <span style={{
                                                                fontSize: "13px",
                                                                fontWeight: 700,
                                                                color: "#1e40af"
                                                            }}>
                                                                ₹ {investment.toFixed(2)}
                                                            </span>
                                                        </div>

                                                        {/* ✅ GST Data Code Variosu Data not communicated the real time examples of that actions */}
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            // gap: "215px",
                                                            marginBottom: "6px"
                                                        }}>
                                                            <span style={{
                                                                fontSize: "12px",
                                                                color: "#374151",
                                                                fontWeight: "bold"
                                                            }}>
                                                                GST (18%)
                                                            </span>

                                                            <span style={{
                                                                fontSize: "13px",
                                                                fontWeight: "bold",
                                                                color: "#1e40af"
                                                            }}>
                                                                ₹ {gst.toFixed(2)}
                                                            </span>
                                                        </div>
                                                        {
                                                            couponApplied && (

                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        marginBottom: "10px"
                                                                    }}
                                                                >

                                                                    <span
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            color: "#16a34a",
                                                                            fontWeight: "bold"
                                                                        }}
                                                                    >
                                                                        Coupon Discount
                                                                    </span>

                                                                    <span
                                                                        style={{
                                                                            fontSize: "13px",
                                                                            fontWeight: 700,
                                                                            color: "#16a34a"
                                                                        }}
                                                                    >
                                                                        - ₹ {couponDiscount.toFixed(2)}
                                                                    </span>

                                                                </div>
                                                            )
                                                        }

                                                        {/* ✅ GRAND TOTAL */}
                                                        <div style={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            marginTop: "10px",
                                                            paddingTop: "10px",
                                                            borderTop: "1px dashed #93c5fd"
                                                        }}>
                                                            <span style={{
                                                                fontSize: "15px",
                                                                fontWeight: 700,
                                                                color: "#1e3a8a"
                                                            }}>
                                                                Grand Total
                                                            </span>

                                                            <span style={{
                                                                fontSize: "17px",
                                                                fontWeight: 800,
                                                                color: "#16a34a"
                                                            }}>
                                                                ₹ {
                                                                    couponApplied
                                                                        ? finalTotal.toFixed(2)
                                                                        : total.toFixed(2)
                                                                }
                                                            </span>
                                                        </div>

                                                        {/* ✅ PAY NOW */}
                                                        <Button
                                                            fullWidth
                                                            variant="contained"
                                                            onClick={handlePayment}
                                                            sx={{
                                                                mt: 2,
                                                                height: "44px",
                                                                borderRadius: "10px",
                                                                fontWeight: 700,
                                                                fontSize: "14px",
                                                                backgroundColor: "#2563eb",
                                                                "&:hover": {
                                                                    backgroundColor: "#1d4ed8"
                                                                }
                                                            }}
                                                        >
                                                            Pay Now ₹{
                                                                couponApplied
                                                                    ? finalTotal.toFixed(2)
                                                                    : total.toFixed(2)
                                                            }
                                                        </Button>

                                                    </>
                                                );
                                            })()}
                                        </div>
                                    </>
                                );
                            })()}
                        </div>


                    ) : null
            )}



            {showPayment && formData.goal === "BOGO_DISCOUNT" && (
                <div>
                    {(() => {
                        const start = new Date(startDate);
                        const end = new Date(endDate);


                        // BOGO Config
                        const bogoConfig = formData?.goalConfig?.bogo || {};

                        // Selected Menu Items
                        const selectedMenuItems = selectedBogoItems || [];

                        // Total Selected Items
                        const totalItems = selectedMenuItems.length;

                        // Billing API Charge
                        const menuChargePerItem = Number(
                            billingData?.menuChargePerItem || 0
                        );

                        // Calculate Total Days
                        const totalDays =
                            startDate && endDate
                                ? Math.ceil(
                                    (new Date(endDate).getTime() -
                                        new Date(startDate).getTime()) /
                                    (1000 * 60 * 60 * 24)
                                ) + 1
                                : 1;
                        // ✅ Menu Charges
                        // Total amount
                        const menuCharges =
                            totalItems *
                            menuChargePerItem *
                            totalDays;

                        const subTotal = menuCharges;
                        const gst = subTotal * 0.18;
                        const total = subTotal + gst;

                        const finalTotal = couponApplied
                            ? Math.max(total - Number(couponDiscount || 0), 0)
                            : total;



                        return (
                            <div
                                style={{
                                    marginTop: "0px",
                                    padding: "14px 16px",
                                    borderRadius: "12px",
                                    background: "#ffffff",
                                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                                    border: "1px solid #e5e7eb",
                                    width: "94%",
                                    margin: "0 auto"
                                }}
                            >
                                <p
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: 700,
                                        marginBottom: "10px",
                                        color: "#1e3a8a",
                                        textAlign: "center"
                                    }}
                                >
                                    🎁 BOGO Payment Summary
                                </p>

                                {/* Budget */}
                                {/* Menu Item Price */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "8px",
                                        color: "#374151",
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Menu Item Price
                                    </span>

                                    <span
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: 600,
                                            color: "#1e40af"
                                        }}
                                    >
                                        {totalItems} Item{totalItems !== 1 ? "s" : ""}

                                        {" × ₹"}

                                        {menuChargePerItem}

                                        {" = ₹"}

                                        {menuCharges.toFixed(2)}
                                    </span>
                                </div>

                                {/* Coupon */}
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "15px",
                                        marginBottom: "12px"
                                    }}
                                >
                                    <input
                                        type="text"
                                        placeholder="Enter Coupon"
                                        value={formData.couponCode || ""}
                                        onChange={(e) =>
                                            onInputChange("couponCode", e.target.value)
                                        }
                                        style={{
                                            width: "180px",
                                            height: "36px",
                                            borderRadius: "10px",
                                            border: "1.5px solid #f97316",
                                            padding: "0 12px",
                                            outline: "none"
                                        }}
                                    />

                                    <Button
                                        variant="contained"
                                        onClick={applyCoupon}
                                        sx={{
                                            minWidth: "80px",
                                            height: "36px",
                                            borderRadius: "10px",
                                            background: "#f97316",
                                            textTransform: "none",
                                            "&:hover": {
                                                background: "#ea580c"
                                            }
                                        }}
                                    >
                                        Apply
                                    </Button>

                                    <span
                                        style={{
                                            fontWeight: 700,
                                            color: "#16a34a"
                                        }}
                                    >
                                        ₹{couponDiscount || 0}
                                    </span>
                                </div>

                                {/* Sub Total */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "8px",
                                        color: "#374151"
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "bold",

                                        }}
                                    >
                                        Sub Total
                                    </span>

                                    <span
                                        style={{
                                            fontWeight: 700,
                                            color: "#1e40af"
                                        }}
                                    >
                                        ₹ {subTotal.toFixed(2)}
                                    </span>
                                </div>

                                {/* GST */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginBottom: "8px",
                                        color: "#374151"
                                    }}
                                >
                                    <span
                                        style={{
                                            fontSize: "12px",
                                            fontWeight: "bold"
                                        }}
                                    >
                                        GST (18%)
                                    </span>

                                    <span
                                        style={{
                                            fontWeight: 700,
                                            color: "#1e40af"
                                        }}
                                    >
                                        ₹ {gst.toFixed(2)}
                                    </span>
                                </div>

                                {/* Coupon Discount */}
                                {couponApplied && (
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            marginBottom: "8px",
                                            color: "#374151"
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontSize: "12px",
                                                color: "#16a34a",
                                                fontWeight: "bold"
                                            }}
                                        >
                                            Coupon Discount
                                        </span>

                                        <span
                                            style={{
                                                fontWeight: 700,
                                                color: "#16a34a"
                                            }}
                                        >
                                            - ₹ {couponDiscount.toFixed(2)}
                                        </span>
                                    </div>
                                )}

                                {/* Grand Total */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        borderTop: "1px dashed #93c5fd",
                                        paddingTop: "10px",
                                        color: "#374151"
                                    }}
                                >
                                    <strong>Grand Total</strong>

                                    <strong
                                        style={{
                                            color: "#16a34a",
                                            fontSize: "16px"
                                        }}
                                    >
                                        ₹ {finalTotal.toFixed(2)}
                                    </strong>
                                </div>

                                <Button
                                    fullWidth
                                    variant="contained"
                                    onClick={handlePayment}
                                    sx={{
                                        mt: 2,
                                        borderRadius: "10px",
                                        fontWeight: 600
                                    }}
                                >
                                    Pay Now ₹{finalTotal.toFixed(2)}
                                </Button>
                            </div>
                        );
                    })()}
                </div>
            )}
        </div>
    );
};

export default AdPreview;